export const NEED_RELOGIN = "NEED_RELOGIN";

export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAILURE = "GET_CURRENT_USER_FAILURE";
export const SET_USER_INFO = "SET_USER_INFO";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
